import RootImpl from './Root.impl';

export default class BaseElectronImplementation {
    root: RootImpl;
    constructor(root: RootImpl) {
        this.root = root;
    }
};